<template>
  <div class="domestic-sidebar">
    <!-- 見出し: 国内宿泊 -->
    <div class="domestic-sidebar__title --top">国内宿泊</div>

    <div class="domestic-sidebar__wrap --input-all">
      <!-- 宿泊地 -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">宿泊地</p>
        <!-- TODO: 複数選択可能になったらisMultipleSelectをtrueに -->
        <ModalPrefectures
          modalType="area"
          labelText="宿泊地"
          placeHoldText="都道府県・市区町村を選択"
          :isError="isError"
          :isLabelDisplay="false"
          :isFixedWidth="true"
          :isMultipleSelect="true"
          @inputed="setDestination"
        />
      </div>
      
      <!-- キーワード検索 -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">キーワード</p>
        <SearchKeyword
          :value="params.keyword"
          placeholder="施設名など"
          :isError="isError"
          :useSearchButton="false"
          @inputed="setKeyword"
        />
      </div>

      <!-- 期間・宿泊日数 -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">期間</p>
        <SelectStayPeriod @inputed="setPeriod" />
      </div>

      <!-- 部屋数 -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">部屋数</p>
        <AppSelectNumber
          :numbers="10"
          :value="params.roomCnt"
          label="部屋"
          class="domestic-sidebar__rooms"
          @inputed="setRooms"
        />
      </div>

      <!-- 1部屋のご利用人数 -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">1部屋のご利用人数</p>
        <SelectNumPeople
          :adultHeadCnt="params.adultHeadCnt"
          :exUpperGradesHeadCnt="params.exUpperGradesHeadCnt"
          :exLowerGradesHeadCnt="params.exLowerGradesHeadCnt"
          :youjiAHeadCnt="params.youjiAHeadCnt"
          :youjiBHeadCnt="params.youjiBHeadCnt"
          :youjiCHeadCnt="params.youjiCHeadCnt"
          :youjiDHeadCnt="params.youjiDHeadCnt"
          @inputed="setNumPeople"
        />
      </div>

      <!-- 1人あたりの料金（1泊） -->
      <div class="domestic-sidebar__wrap">
        <p class="domestic-sidebar__heading">予算（総額）</p>
        <SelectPriceRange
          :feeLower="params.feeLower"
          :feeUpper="params.feeUpper"
          @inputed="setPrice"
        />
      </div>

      <!-- この条件で絞り込むボタン -->
      <div class="domestic-sidebar__wrap">
        <AppButton
          label="この条件で絞り込む"
          theme="black"
          @clicked="clicked"
        />
      </div>

      <!-- 見出し: こだわり条件 -->
      <div class="domestic-sidebar__title --special">こだわり条件</div>

      <!-- 部屋タイプ -->
      <div class="domestic-sidebar__wrap">
        <div class="domestic-sidebar__heading --special">部屋タイプ</div>
        <SelectSpecialConditions
          v-if="roomType.length > 0"
          :list="roomType"
          class="domestic-sidebar__select-special-conditions --room-type"
          @changed="newList => setSpecialConditions(newList, 'roomType')"
        />
      </div>

      <!-- 食事条件 -->
      <div class="domestic-sidebar__wrap">
        <div class="domestic-sidebar__heading --special">食事条件</div>
        <SelectSpecialConditions
          v-if="mealCondition.length > 0"
          :list="mealCondition"
          @changed="newList => setSpecialConditions(newList, 'mealCondition')"
        />
      </div>

      <!-- ボタン -->
      <div class="domestic-sidebar__wrap">
        <!-- さらに条件を追加するボタン -->
        <AppButton
          label="さらに条件を追加する"
          theme="gray"
          class="domestic-sidebar__button --more"
          @clicked="isModalVisible = true"
        />
        <!-- この条件で絞り込むボタン -->
        <AppButton
          label="この条件で絞り込む"
          theme="black"
          @clicked="clicked"
        />
      </div>

      <!-- こだわり条件モーダル -->
      <div class="domestic-sidebar__modal">
        <ModalSpecialConditions
          :isVisible="isModalVisible"
          :facility="facility"
          :roomType="roomType"
          :mealCondition="mealCondition"
          :roomCondition="roomCondition"
          :serviceEquip="serviceEquip"
          :usageMethod="usageMethod"
          :planByCompany="planByCompany"
          @inputed="setSpecialConditionsFromModal"
          @closed="closed"
        />
      </div>
    </div>
  </div>
</template>

<script>
import specialConditionsList from '../specialConditionsList.json'
import specialConditionsListAddSupplementary from '../specialConditionsListAddSupplementary.json'
import SearchKeyword from '../SearchKeyword/'
// import SelectModal from '../SelectModal/'
import SelectStayPeriod from'../SelectStayPeriod/'
import SelectNumPeople from'../SelectNumPeople/'
import SelectPriceRange from '../SelectPriceRange/'
import SelectSpecialConditions from '../SelectSpecialConditions'
import ModalSpecialConditions from '../ModalSpecialConditions'
import ModalPrefectures from '../ModalPrefectures'
import AppButton from '@/components/elements/AppButton/'
import AppSelectNumber from '@/components/elements/AppSelectNumber/'

export default {
  components: {
    SearchKeyword,
    // SelectModal,
    SelectStayPeriod,
    SelectNumPeople,
    SelectPriceRange,
    SelectSpecialConditions,
    ModalPrefectures,
    ModalSpecialConditions,
    AppButton,
    AppSelectNumber,
  },
  props: {
    isShowSupplementaryCoupon: {
      type: Boolean,
      default: false
    }, // 補助クーポンが使えるが出現するフラグ
    isShowCafeteriaPoint: {
      type: Boolean,
      default: false
    }, // カフェテリアポイントが使えるが出現するフラグ
    isError: {
      type: Boolean,
      required: false,
      default: false
    }, // エラー状態
  },
  data() {
    return {
	  dest: [],
      facility: [],               // 施設タイプ（データ加工用）
      roomType: [],               // 部屋タイプ（データ加工用）
      mealCondition: [],          // 食事条件（データ加工用）
      roomCondition: [],          // 部屋のこだわり（データ加工用）
      serviceEquip: [],           // 設備・サービス（データ加工用）
      usageMethod: [],            // 利用方法（データ加工用）
      planByCompany: [],          // 提供会社（データ加工用）

      params: {                   // BFFリクエスト用パラメータ
        numPeople: 1,             // 合計人数
        adultHeadCnt: 1,          // 大人の人数
        feeLower: '0',            // 下限金額
        feeUpper: '0',            // 上限金額
        facility: '',             // 施設タイプ
        roomType: '',             // 部屋タイプ
        mealCondition: '',        // 食事条件
        roomCondition: '',        // 部屋のこだわり
        serviceEquip: '',         // 設備・サービス
        usageMethod: '',          // 利用方法
        planByCompany: '',        // 提供会社
        checkInDate: '',          // 宿泊開始日
        areaLrgClassCd: '',       // 地方
        areaMidClassCd: '',       // 都道府県
        areaSmlClassCd: '',       // 市区町村
        areaDtlClassCd: '',       // エリア
        keyword: '',              // 検索キーワード
        stayNights: 1,            // 宿泊日数
        orderBy: 'PROPOSE',       // ソート条件（「おすすめ順」がデフォルト）
        category: 'stay',         // 国内宿泊施設（stay）
        exUpperGradesHeadCnt: 0,  // 高学年
        exLowerGradesHeadCnt: 0,  // 低学年
        youjiAHeadCnt: 0,         // 食事・布団付き
        youjiBHeadCnt: 0,         // 食事のみ
        youjiCHeadCnt: 0,         // 布団のみ
        youjiDHeadCnt: 0,         // 食事・布団不要
        roomCnt: 1,               // 部屋数
      },
      isModalVisible: false,       // こだわり条件モーダルの表示状態
    }
  },
  watch: {
    isShowSupplementaryCoupon() {
      this.initStateFromQuery()
    },
    isShowCafeteriaPoint() {
      this.initStateFromQuery()
    },
  },
  created() {
    this.initStateFromQuery()
  },
  methods: {
    /**
     * 「この条件で絞り込む」ボタンが押下されたら
     */
    clicked() {
      this.setOrderBy()
      this.$emit('inputed', this.params,this.dest)
    },
    /**
     * モーダルが閉じられたら
     */
    closed() {
      this.isModalVisible = false
      this.setOrderBy()
      this.$emit('inputed', this.params,this.dest)
    },
    /**
     * 初期値をクエリパラメータから取得し、反映
     */
    initStateFromQuery() {
      const query = this.$route.query
      const keys = Object.keys(this.params)

      keys.forEach(key => {
        this.params[key] = query?.[key] || this.params[key]
      })

      this.initSpecialConditions()
    },
    /**
     * こだわり条件の初期化（チェック状態のプロパティを追加）
     */
    initSpecialConditions() {
      const cafeAndSubsidy = []

      if (this.isShowCafeteriaPoint) {
        cafeAndSubsidy.push({ "id": "canUseCafeteriaPoint", "label": "カフェテリアポイントが使える" })
      }

      if (this.isShowSupplementaryCoupon) {
        cafeAndSubsidy.push({ "id": "canUseSubsidy", "label": "補助クーポンが使える" })
      }

      const list = cafeAndSubsidy.length > 0
        ? specialConditionsList.map(d => {
          if (d.id === 'usageMethod') {
            return {
              ...d,
              list: [...d.list, cafeAndSubsidy].flat()
            }
          } else {
            return { ...d }
          }
        })
        : specialConditionsList

      list.forEach(item => {
        const currentCheckedItems = this.params[item.id].split(',')

        this[item.id] = item.list.map(data => {
          if (currentCheckedItems.includes(data.id)) {
            return { ...data, checked: true }
          }
          return { ...data, checked: false }
        })
      })
    },
    /**
     * 並び替えを設定
     * 並び替えだけ独立した検索条件なので
     * emit時にqueryから都度取得する
     */
    setOrderBy() {
      const query = this.$route.query
      this.params.orderBy = query?.orderBy
    },
    /**
     * keywordを設定
     */
    setKeyword(value) {
      this.params.keyword = value
    },
    /**
     * SelectDestinationからemitされたobjectから値を設定
     */
    setDestination(obj) {
      this.dest = obj;
      this.params.areaLrgClassCd = obj.region_id
      this.params.areaMidClassCd = obj.large_id
      this.params.areaSmlClassCd = obj.medium_id
      this.params.areaDtlClassCd = obj.small_id
    },
    /**
     * SelectStayPeriodからemitされたobjectから値を設定
     */
    setPeriod(obj) {
      this.params.checkInDate = obj.checkInDate
      this.params.stayNights = obj.stayNights
    },
    /**
     * AppSelectNumberからemitされたroomCntを設定
     */
    setRooms(value) {
      this.params.roomCnt = Number(value) || 0
      // roomsはroomCntと同じらしい
      this.params.rooms = Number(value) || 0
    },
    /**
     * 
     * @param {*} obj 
     */
    setNumPeople(obj) {
      this.params.adultHeadCnt = obj.adultHeadCnt
      this.params.exLowerGradesHeadCnt = obj.exLowerGradesHeadCnt
      this.params.exUpperGradesHeadCnt = obj.exUpperGradesHeadCnt
      this.params.youjiAHeadCnt = obj.youjiAHeadCnt
      this.params.youjiBHeadCnt = obj.youjiBHeadCnt
      this.params.youjiCHeadCnt = obj.youjiCHeadCnt
      this.params.youjiDHeadCnt = obj.youjiDHeadCnt

      // 食事のみ、食事・布団不要は人数に含まない
      this.params.numPeople =
        Number(obj.adultHeadCnt) +
        Number(obj.exLowerGradesHeadCnt) +
        Number(obj.exUpperGradesHeadCnt) +
        Number(obj.youjiAHeadCnt) +
        Number(obj.youjiCHeadCnt)
    },
    setPrice(obj) {
      this.params.feeLower = obj.feeLower
      this.params.feeUpper = obj.feeUpper
    },
    /**
     * SelectSpecialConditionsからemitされたこだわり条件を設定
     */
    setSpecialConditions(newList, type) {
      this[type] = newList

      // checkedの真偽値だけを抽出し、paramsへ「hoge,fuga...」の形式で代入
      const checkedItems = newList
        .filter(d => d.checked)
        .map(d => d.id).join()
      this.params[type] = checkedItems
    },
    /**
     * ModalSpecialConditionsで設定された値を設定
     */
    setSpecialConditionsFromModal(obj) {
      const cafeAndSubsidy = []

      if (this.isShowCafeteriaPoint) {
        cafeAndSubsidy.push({ "id": "canUseCafeteriaPoint", "label": "カフェテリアポイントが使える" })
      }

      if (this.isShowSupplementaryCoupon) {
        cafeAndSubsidy.push({ "id": "canUseSubsidy", "label": "補助クーポンが使える" })
      }

      const list = cafeAndSubsidy.length > 0
        ? specialConditionsList.map(d => {
          if (d.id === 'usageMethod') {
            return {
              ...d,
              list: [...d.list, cafeAndSubsidy].flat()
            }
          } else {
            return { ...d }
          }
        })
        : specialConditionsList

      // keyのみの配列作成
      const types = list.map(d => d.id)

      types.forEach(type => {
        // this.facility, this.roomType等に、modalが返したcheckedを更新したリストを代入
        this[type] = obj[type]

        // checkedの真偽値だけを抽出し、paramsへ「hoge,fuga...」の形式で代入
        const checkedItems = obj[type]
          .filter(d => d.checked)
          .map(d => d.id).join()
        this.params[type] = checkedItems
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.domestic-sidebar {

  &__wrap {
    padding: 0 1rem 1rem;

    &.--input-all {
      border: 2px solid $cool-gray-4;
      border-radius: .5rem;
      padding: 1rem 0 0;
    }
  }

  &__title {
    color: $black;
    font-weight: bold;
    line-height: 1.5;

    &.--top {
      border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
      font-size: 1.25rem;
      margin-bottom: 1.5rem;
    }

    &.--special {
      background-color: $cool-gray-5;
      font-size: .875rem;
      margin-bottom: 1rem;
      padding: .5rem 1rem;
    }
  }

  &__heading {
    font-size: .875rem;
    font-weight: bold;
    margin-bottom: .25rem;

    &.--special {
      margin-bottom: 1rem;
    }
  }

  &__block {
    &.--destination {
      align-items: center;
      align-content: stretch;
      display: flex;
      font-size: .75rem;
      line-height: 1.25;
      padding: .5rem 0;

      &::before {
        content: '設定中:';
        display: block;
        flex-shrink: 0;
        margin-right: .5rem;
      }
    }
  }

  &__rooms {
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    height: 2.5rem;
    width: 100%;
  }

  &__select-special-conditions {
    &.--room-type {
      border-bottom: 1px solid $cool-gray-4;
      padding-bottom: 1rem;
    }
  }

  &__button {
    &.--more {
      margin-bottom: .5rem;
    }
  }
}
</style>